module.exports = __webpack_public_path__ + "static/media/photo-1569092433665-20d853fd0934.bb7c49c3.jpg";